import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const SportsmanStatSummaryContext = createContext<{
  params?: Routing.SportsmanStatSummaryParams
}>({})

export { SportsmanStatSummaryContext }
